import React from "react";
import { PropertyType } from "src/types";
import { mockProperties } from "../../constants/mockProperties";
import { members } from "./components";
import DynamicSlider from "./components/DynamicSlider";
import ContactMandate from "./components/ContactMandate";
import { TeamCardWhatsapp } from "./components/TeamCard";
import SimilarProperties from "./components/SimilarProperties";
import { BranchSummaryCard } from "./Branches";
import PropertyUtilities from "../../constants/utilitiesIcons";
import { ProfileSummary } from "../../constants/branchData";
import { getCurrencySign } from "src/app/lib/getCurrencySign";
export function camelCaseToWords(camelCaseStr: string): string {
  if (!camelCaseStr) {
    return "Data not available";
  }
  return camelCaseStr
    .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space before uppercase letters
    .replace(/^./, (char) => char.toUpperCase()); // Capitalize the first letter
}
export const propertyDataCharge: ProfileSummary = {
  title: "Price & Other Charges",
  values: {
    property_price: "₦3,300,300",
    agency_fee: "₦3,300,300",
    inspection_fee: "₦3,300,300",
    other_fee: "₦3,300,300",
  },
};
export const propertyData: ProfileSummary = {
  title: "Property Information",
  values: {
    property_title: "Obolongo Estate",
    category: "Residential",
    unit: "Unit 3 Bedroom, 1 Unit Self Contained With Penthouse",
    document: "C of O, Record Copy Survey, Agreement",
    source_owner: "Ibrahim Matthew",
    total_area: "4354 sqm",
    offer: 21,
    total_views: 121,
    bookmarks: 21,
    added_date: "21/01/2025",
    last_updated: "21/01/2025",
  },
};
const PropertyPage1 = () => {
  return (
    <section className="py-10 w-full overflow-clip">
      <div className="wrapper">
        <div className="grid-container relative">
          <div className="item flex flex-col gap-5">
            <div className="carousel w-auto">
              <DynamicSlider
                slides={[...mockProperties["forRent"][0].images]}
              />
            </div>
            <div className="carousel my-4">
              <div className="first flex items-center justify-between">
                <h3 className="font-semibold">
                  {mockProperties.forRent[0].title}
                </h3>
                <span className="text-label-main">
                  Property ID: {mockProperties.forRent[0].id}
                </span>
              </div>
              <div className="first flex items-center justify-between">
                <h5 className="text-label flex gap-1">
                  <LocationIcon />
                  {mockProperties.forRent[0].address}
                </h5>
                <span className="text-themeColor capitalize">
                  {mockProperties.forRent[0].category}
                </span>
              </div>
            </div>
            <ParentCard header="Property Brief">
              <div
                className="flex flex-col gap-2 text-secondary-main"
                dangerouslySetInnerHTML={{
                  __html: mockProperties.forRent[0].propertyDesc as string,
                }}
              />
            </ParentCard>
            <ParentCard header="Facilities">
              <PropertyUtilities selectedItems={utilities} />
            </ParentCard>
            <BranchSummaryCard variant {...propertyData} />
            <BranchSummaryCard variant {...propertyDataCharge} />
            <ParentCard header="Document">
              <p>C of O. Record Copy Survey, Agreement</p>
            </ParentCard>
          </div>
          <div className=" w-full flex flex-col gap-14">
            <PriceCard {...mockProperties.forRent[0]} />
            <div className="card mt-14">
              <TeamCardWhatsapp {...members[0]} />
            </div>
            <ContactMandate email={members[0].email} />
          </div>
        </div>
        <SimilarProperties
          arr={[...mockProperties["forSale"], ...mockProperties["forSale"]]}
        />
      </div>
    </section>
  );
};
export default PropertyPage1;

export const PriceCard: React.FC<PropertyType> = ({
  price,
  priceType,
  currency,
  quotePrice,
  quote,
  beforePrice,
  discount,
}) => {
  const formattedCurrency = getCurrencySign(currency);
  return (
    <ParentCard className="!overflow-visible" header="Price">
      {beforePrice && (
        <div className="line-through">
          <div className="flex text-secondary-main items-center">
            <span className="text-secondary-main">Before: </span>{" "}
            <span className=" font-semibold">
              {formattedCurrency}
              {beforePrice.toLocaleString()}
            </span>
          </div>
        </div>
      )}
      <h3 className="text-themeColor leading-none flex gap-2 items-end font-semibold">
        {formattedCurrency}
        {price.toLocaleString()}
        {discount && <span className=" text-sm text-secondary-main">Now</span>}
      </h3>
      {discount && ( // If discount is available  display it
        <div className="flex text-themeColor items-center gap-1">
          <span className="text-themeColor font-semibold">{discount}</span>
          <span className="text-themeColor">Discount on Initial Price </span>
        </div>
      )}
      <div className="other flex flex-col">
        <span className="block mb-4 text-secondary-main text-[16px]">
          {camelCaseToWords(camelCaseToWords(priceType))}:
        </span>
        <div className="price flex items-end gap-1">
          {" "}
          <span className="text-themeColor font-semibold items-end text-2xl">
            {formattedCurrency}
            {quotePrice.toLocaleString()}
          </span>{" "}
          <span className="flex gap-1"> / {camelCaseToWords(quote)}</span>
        </div>
      </div>
    </ParentCard>
  );
};

export const ParentCard: React.FC<{
  children: React.ReactNode;
  header: string;
  variant?: boolean;
  className?: string;
  headingTag?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}> = ({ children, header, variant, className = "", headingTag = "h2" }) => {
  const HeadingTag = headingTag;

  return (
    <div
      style={{
        boxShadow: "0px 2px 10px 0px #2121210D",
      }}
      className={`p-4 bg-white text-secondary-main overflow-hidden ${className} rounded-xl`}
    >
      <HeadingTag
        className={`mb-4 sub-header h5 !font-bold pb-3 text-secondary-main border-b border-b-disabled-main/50 ${
          variant && "!border-b-themeColor"
        } font-semibold`}
      >
        {header}
      </HeadingTag>
      <div className="children">{children}</div>
    </div>
  );
};

export const LocationIcon = () => {
  return (
    <svg
      width="19"
      height="24"
      viewBox="0 0 19 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_631_48647)">
        <path
          d="M9.39215 13.512C11.121 13.512 12.5226 12.1104 12.5226 10.3815C12.5226 8.65264 11.121 7.2511 9.39215 7.2511C7.66326 7.2511 6.26172 8.65264 6.26172 10.3815C6.26172 12.1104 7.66326 13.512 9.39215 13.512Z"
          stroke="#606060"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.39079 2.03235C7.17681 2.03235 5.05351 2.91185 3.48799 4.47737C1.92247 6.04289 1.04297 8.16619 1.04297 10.3802C1.04297 12.3544 1.46245 13.6463 2.60819 15.0758L9.39079 22.9019L16.1734 15.0758C17.3191 13.6463 17.7386 12.3544 17.7386 10.3802C17.7386 8.16619 16.8591 6.04289 15.2936 4.47737C13.7281 2.91185 11.6048 2.03235 9.39079 2.03235Z"
          stroke="#606060"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_631_48647">
          <rect width="18.7826" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const utilities = [
  "Drainage",
  "Fence",
  "Interlocking",
  "Gated Estate",
  "Swimming",
  "Car Parking",
  "Restaurant",
  "W/Heater",
  "Play Ground",
  "Church",
  "Mosque",
  "Bathtubs",
  "Intercom",
  "Security",
  "Borehole",
  "AC",
  "Supermarket",
  "POP Ceiling",
  "Laundry",
  "Wi-fi",
  "Gym & Fit",
];

// https://www.youtube.com/watch?v=L9ZGqeUas-k

export const Info: React.FC<{
  title: string;
  id: number;
  address: string;
  category: string;
}> = ({ title, id, address, category }) => {
  return (
    <div className="carousel flex  justify-between my-4">
      <div className="first ">
        <h1 className="font-semibold h3 text-primary">{title}</h1>
        <h5 className="text-label-main capitalize flex gap-1">
          <LocationIcon />
          {address}
        </h5>
      </div>
      <div className="first flex items-end flex-col ">
        <span className="text-label-main whitespace-nowrap">
          (Property ID: {id})
        </span>
        <span className="text-themeColor font-semibold capitalize">
          {category}
        </span>
      </div>
    </div>
  );
};
